module.exports = __webpack_public_path__ + "media/images/lp/bg-logged-indique-0382db6ee0f7636e20f0a20e5c33708d.png";